import React from 'react';
import { MobileView, isMobile } from "react-device-detect";
import { BrowserRouter } from "react-router-dom";
import Routes from "./routers/Routes";
import Mobile from './pages/screens/Mobile/Mobile';
import { AuthProvider } from './context/AuthContext';
import { TmpThemeCustom } from './themes/TmpThemeCustom';
import { ThemeProvider } from '@material-ui/core';

function App() {

    document.title = document.title + " - " + process.env.REACT_APP_API_ENVIRONMENT
    console.log('%cHospital Sírio-Libanês - Serviço de Apoio ao Médico - SAM', 'color: blue; font-size: 16px;');

    const browser = (

        <ThemeProvider theme={TmpThemeCustom}>
            <AuthProvider>
                <BrowserRouter>
                    <Routes />
                </BrowserRouter>
            </AuthProvider>
        </ThemeProvider>
    )

    const mobile = (
        <MobileView>
            <Mobile />
        </MobileView>
    )

    if (isMobile) {
        return mobile;
    } else {
        return browser;
    }
}

export default App;